import './Badge.css';

const VARIANT_TO_COLOR = {
  buy:      'positive',
  positive: 'positive',
  sell:     'negative',
  negative: 'negative',
  sim:      'sim',
  live:     'live',
  neutral:  'neutral',
  warning:  'warning',
};

export default function Badge({ variant = 'neutral', size = 'sm', children }) {
  const color = VARIANT_TO_COLOR[variant] ?? 'neutral';
  return (
    <span className={`badge badge--${color} badge--${size}`}>
      {children}
    </span>
  );
}
